module.exports = __webpack_public_path__ + "static/media/ct-tlh-ct-evr-trend-gigigala-tl-0420-11-jpg-20170421.b42d09ce.jpg";